import React from 'react'
import AgentSalesView from '../components/dashboard/AgentSalesView'

const OrangeAgentSalesPage = () => (
  <AgentSalesView
    operator="orange"
    title="Orange — Sprzedaż per Agent"
    description="Agregacja sprzedaży per agent (firma) z drill-down do salonów oraz danymi kontaktowymi RKSA / XDM / RDS D2D. Eksport Excel jest podstawą pod automatyczną wysyłkę raportów (Phase 2)."
  />
)

export default OrangeAgentSalesPage
